import { put } from "redux-saga/effects";
import {
  getDiagnostic,
  checkoutPayment,
  claimItem,
  calculateItem,
  OnePaymentTransaction,
} from "../../Services";

export function* getDiagnosticSaga(action) {
  const payload = action.payload;

  try {
    const res = yield getDiagnostic(payload);
    yield put({ type: "REQ_GET_DIAGNOSTIC_SUCCEEDED", data: res.data });
  } catch (err) {
    yield put({ type: "REQ_GET_DIAGNOSTIC_FAILED", errData: err });
  }
}

export function* checkoutPaymentSaga(action) {
  console.log("run..", action);
  const payload = action.payload;
  try {
    const res = yield checkoutPayment(payload);
    yield put({ type: "REQ_CHECKOUT_PAYMENT_SUCCEEDED", data: res.data });
  } catch (err) {
    console.log("tee", err);
    yield put({ type: "REQ_CHECKOUT_PAYMENT_FAILED", errData: err });
  }
}

export function* claimItemSaga(action) {
  const payload = action.payload;

  try {
    const res = yield claimItem(payload);
    yield put({ type: "REQ_CLAIM_ITEM_SUCCEEDED", data: res.data });
  } catch (err) {
    yield put({ type: "REQ_CLAIM_ITEM_FAILED", errData: err });
  }
}

export function* calculateItemSaga(action) {
  const payload = action.payload;

  try {
    const res = yield calculateItem(payload);
    yield put({ type: "REQ_CALCULATE_ITEM_SUCCEEDED", data: res.data });
  } catch (err) {
    yield put({ type: "REQ_CALCULATE_ITEM_FAILED", data: err });
  }
}

export function* AllinOnePaymentTransaction(action) {
  try {
    const res = yield OnePaymentTransaction(action.payload);
    if (res.data.success) {
      yield put({ type: "REQ_ONE_PAYMENT_SUCCESS", data: res.data });
    } else {
      yield put({ type: "REQ_ONE_PAYMENT__FAILED", errData: res.data });
    }
  } catch (error) {
    yield put({ type: "REQ_ONE_PAYMENT__FAILED", errData: error });
  }
}
